export default __webpack_public_path__ + "static/beginrs_logo-02d14f8c7cce922212f1d30c0279efc4.jpeg";